<template>
    <md-dialog md-open-from="#autoNumberCues" md-close-to="#autoNumberCues" ref="autoNumberCues">
        <div style="text-align: center;">
            <div style="padding: 14px; padding-bottom: 0px;">
                <md-dialog-content>
                    <p>Auto Number Selected Cues</p>
                    <br/>
                    <div class="auto-number-fields">
                        <md-input-container>
                            <label for="auto-number-start">Starting Number*</label>
                            <md-input
                                id="auto-number-start"
                                type="number"
                                required
                                v-model.trim="startingNumber"
                                @input="validate"
                            />
                        </md-input-container>
                        <md-input-container>
                            <label for="auto-number-interval">Interval*</label>
                            <md-input
                                id="auto-number-interval"
                                type="number"
                                required
                                v-model.trim="interval"
                                @input="validate"
                            />
                        </md-input-container>
                    </div>
                    <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
                    <md-button
                        class="md-primary md-raised"
                        style="margin-bottom: 25px;"
                        :disabled="btnDisabled"
                        @click="submit"
                    >AUTO NUMBER</md-button>
                </md-dialog-content>
            </div>
        </div>
    </md-dialog>
</template>

<script>
import Utils from '@/lib/Utils';

const AutoNumberCues = {
    name: 'autoNumberCues',
    data: function() {
        return {
            startingNumber: '',
            interval: 1,
            errorMessage: '',
            btnDisabled: true
        };
    },
    methods: {
        validate() {
            if (!Utils.isValidCueNumberSeed(this.startingNumber)) {
                this.btnDisabled = true;
                this.errorMessage = 'Please enter a valid starting number.';
                return;
            }
            if (!Utils.isValidCueInterval(this.interval)) {
                this.btnDisabled = true;
                this.errorMessage = 'Interval must be a number greater than 0.';
                return;
            }
            this.btnDisabled = false;
            this.errorMessage = '';
        },
        open() {
            this.startingNumber = '';
            this.interval = 1;
            this.errorMessage = '';
            this.btnDisabled = true;
            this.$refs.autoNumberCues.open();
            this.$emit('dialog-state-change', true);
        },
        submit() {
            this.validate();
            if (this.btnDisabled) {
                return;
            }
            this.$emit('auto-number', {
                startNumber: Number(this.startingNumber),
                interval: Number(this.interval)
            });
            this.close();
        },
        close() {
            this.$refs.autoNumberCues.close();
            this.$emit('dialog-state-change', false);
        }
    }
};
export default AutoNumberCues;
</script>

<style>
.auto-number-fields {
    display: flex;
    justify-content: center;
    gap: 16px;
}
</style>


// WEBPACK FOOTER //
// auto-number-cues.vue?279ff6e4